// Backport Bootstrap 5.3+ parseSelector behavior for navigation.js tab IDs.
// navigation.js builds targets like "#nav-/pabean_report/...-----uid".
// Those are valid HTML ids, but invalid CSS #id selectors unless escaped.
(() => {
  if (typeof CSS === "undefined" || typeof CSS.escape !== "function") return

  const escapeIds = (selectors) => {
    if (typeof selectors !== "string" || !selectors.includes("#")) return selectors
    return selectors.replace(/#([^\s"#']+)/g, (_match, id) => `#${CSS.escape(id)}`)
  }

  const patch = (proto, method) => {
    const original = proto[method]
    if (typeof original !== "function") return

    proto[method] = function (selectors) {
      try {
        return original.call(this, selectors)
      } catch (error) {
        if (error instanceof DOMException) {
          return original.call(this, escapeIds(selectors))
        }
        throw error
      }
    }
  }

  patch(Document.prototype, "querySelector")
  patch(Document.prototype, "querySelectorAll")
  patch(Element.prototype, "querySelector")
  patch(Element.prototype, "querySelectorAll")
})()
